import { render, staticRenderFns } from "./CartProgressBar.vue?vue&type=template&id=98f47edc"
import script from "./CartProgressBar.vue?vue&type=script&lang=js"
export * from "./CartProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports